module.exports = __webpack_public_path__ + "assets/flags/4x3//bd7494930614f3487d718a4dca63d9a5.svg";